import { render, staticRenderFns } from "./ShpsList.vue?vue&type=template&id=bedbe4a0&scoped=true&"
import script from "./ShpsList.vue?vue&type=script&lang=js&"
export * from "./ShpsList.vue?vue&type=script&lang=js&"
import style0 from "./ShpsList.vue?vue&type=style&index=0&id=bedbe4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedbe4a0",
  null
  
)

export default component.exports